import { LedgerEntriesTable } from "@/components/shared/ledger/ledger-entries-table";

export const LedgerTableContainer = () => {
  return (
    <LedgerEntriesTable
      tableName="ledger"
      queryKeyPrefix="ledger"
      storageKey="ledger"
    />
  );
};
